import styled from "styled-components";

export const BasketballArtStyled = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;
